import ReactFlagsSelect from 'react-flags-select';
import React, {useState} from 'react';
import {getSelectedCountry, langToCountry} from "../../appUtil";
import {setMomentLocale} from "../../moment/momentFormat";
import i18next from "i18next";

const SHORT_LABELS = {GB: 'GB', PL: 'PL', IN: 'IN'};

function FlagSelector() {
    const [selected, setSelected] = useState(getSelectedCountry());
    return (
        <ReactFlagsSelect
            onSelect={countryCode => onSelectFlag(countryCode)}
            selected={selected}
            countries={getCountries()}
            customLabels={SHORT_LABELS}
            showSelectedLabel={true}
            fullWidth={false}
            alignOptionsToRight
        />
    );

    function getCountries() {
        return Object.values(langToCountry);
    }
    function onSelectFlag(countryCode){
        setSelected(countryCode)
        let lang = Object.keys(langToCountry).find(key => langToCountry[key] === countryCode);
        i18next.changeLanguage(lang + "-" + countryCode)
        setMomentLocale();
    }
}

export default FlagSelector;